import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-shengchanliucheng",
  "use": "icon-shengchanliucheng-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-shengchanliucheng\"><path d=\"M246.4 342.4l256 118.4 256-118.4-256-118.4-256 118.4z m-92.8-28.8L489.6 160c9.6-3.2 19.2-3.2 25.6 0l336 153.6c16 6.4 22.4 25.6 16 41.6-3.2 6.4-9.6 12.8-16 16l-336 153.6c-9.6 3.2-19.2 3.2-25.6 0L153.6 371.2c-16-6.4-22.4-25.6-16-41.6 3.2-6.4 9.6-12.8 16-16z\" fill=\"#50E3C2\" /><path d=\"M508.8 627.2L841.6 480c16-6.4 35.2 0 41.6 16 6.4 16 0 35.2-16 41.6l-361.6 160-361.6-160c-16-6.4-22.4-25.6-16-41.6 9.6-16 28.8-25.6 44.8-16l336 147.2z\" fill=\"#597EF7\" /><path d=\"M841.6 640c16-6.4 35.2 0 41.6 16 6.4 16 0 35.2-16 41.6l-361.6 160-361.6-160c-16-6.4-22.4-25.6-16-41.6 9.6-16 28.8-25.6 44.8-16l336 150.4L841.6 640z\" fill=\"\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/shengchanliucheng.svg
// module id = 8tI3
// module chunks = 67